<template>
  <BravadoTheme class="layout layout--clear">
    <div :class="rootClass">
      <ClientOnly>
        <TopNotification />
      </ClientOnly>
      <WarRoomMobileAppBannerTop v-if="!hasJustCompletedOnboarding" />
      <nuxt />
      <GlobalComponents />
    </div>
  </BravadoTheme>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default defineComponent({
  name: 'ClearLayout',
  mixins: [defaultLayoutMixin],
  computed: {
    rootClass() {
      return ['clear-layout'];
    },
    hasJustCompletedOnboarding() {
      return !!this.$route.query.personalizedRoute;
    },
  },
});
</script>
